// This is the side data
const menuItems = [
  {
    title: "Assignment Management",
    subOptions: ["Assignments"],
  },

  {
    title: "Courses & Discussions",
    subOptions: ["Courses"],
  },

  {
    title: "Curriculum Management",
    subOptions: ["Subjects", "Chapters", "Topics", "Sub Topics"],
  },

  {
    title: "Packages Management",
    subOptions: ["Packages"],
  },

  {
    title: " Schedule & Timetable",
    subOptions: ["Timetable", "Schedule Class"],
  },
  {
    title: "Teacher Management",
    subOptions: ["Teacher Overview"],
  },

  // {
  //   title: "Student Management",
  //   subOptions: [
  //     "Students",
  //     "All Students",
  //     "Student Info",
  //     "Student Coins",
  //     "Profile History",
  //     "Crash Course Info",
  //     "Student Suggestions",
  //     "Latest Updates",
  //   ],
  // },

  // {
  //   title: "Question Management",
  //   subOptions: [
  //     "Chapters",
  //     "Topics",
  //     "Difficulty Levels",
  //     "Questions",
  //     "Question Reports",
  //     "Rank booster problems",
  //   ],
  // },
  // {
  //   title: "Exam Management",
  //   subOptions: ["Exam"],
  // },
  // {
  //   title: "Previous Year Papers",
  //   subOptions: ["Questions", "Question Reports"],
  // },

  // {
  //   title: "Concept",
  //   subOptions: ["Sub Topics", "Page Reports", "Question Reports"],
  // },
  // {
  //   title: "Packages",
  //   subOptions: ["Dashboard", "Settings", "Reports"],
  // },
  // {
  //   title: "Reedeem Products",
  //   subOptions: ["Reedeem Products", "Reedeem Orders", "JEE Rankers"],
  // },
  // {
  //   title: "Forumns",
  //   subOptions: ["Forums"],
  // },
  // {
  //   title: "Landing Pages",
  //   subOptions: ["Exam Portal", "Video Portal", "PYQ"],
  // },
  // {
  //   title: "CMS Management",
  //   subOptions: ["Dashboard", "Settings", "Reports"],
  // },
  // {
  //   title: "Master Data",
  //   subOptions: [
  //     "Badges",
  //     "Lectures",
  //     " Matrixmatch Points",
  //     "All Time rankings",
  //     "Whatsapp Links",
  //   ],
  // },
  // {
  //   title: "Sub Admins",
  //   subOptions: ["Sub Admins"],
  // },
  // { title: " Web Settings ", subOptions: ["Web Settings"] },
  // { title: "Settings", subOptions: ["Username & Password", "Logout"] },
];

export default menuItems;
